<template>
  <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
    <template v-if="showTo">
      <el-form-item label="申请单号：" prop="approvalNumber">
        <el-input v-model="searchForm.approvalNumber" placeholder="申请单号" />
      </el-form-item>
      <el-form-item label="项目名称：" prop="projectName">
        <el-input v-model="searchForm.projectName" placeholder="项目名称" />
      </el-form-item>
      <el-form-item label="合同编号：" prop="contractNum">
        <el-input v-model="searchForm.contractNum" placeholder="合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="orderUnit">
        <el-input v-model="searchForm.orderUnit" placeholder="代理商名称" />
      </el-form-item>
    </template>
    <el-form-item label="申请时间：" prop="createBeginTime">
      <div class="rj-flex">
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.createBeginTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
          />
        </div>
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.createEndTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
          />
        </div>
      </div>
    </el-form-item>
    <el-form-item>
      <slot :form="searchForm" />
    </el-form-item>
  </el-form>
</template>
<script type="es6">
export default {
  props: {
    showTo: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      searchForm: {
        contractNum: '',
        projectName: '',
        orderUnit: '',
        approvalNumber: '',
        createBeginTime: null,
        createEndTime: null
      }
    };
  },
  methods: {
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createBeginTime = null;
      this.searchForm.createEndTime = null;
    }

  }
};
</script>
